import { useSelectSlice } from "@common/redux/selectors/useSelectSlice"
import { ticketsBundlesSlice } from "@common/redux/slices/entities.slice"
import { Layout } from "@kursk/components/Layout/Layout";
import styles from './TicketsBundles.module.scss';
import { RecommendationsBlock } from "@kursk/components/ui/RecommendationsBlock/RecommendationsBlock";
import { recommendationSlice } from "@common/redux/slices/recommendation.slice";
import { Socials } from "../Home/Socials/Socials";
import { getEntitiesListTitle } from "@kursk/utils/getEntitiesListTitle";
import { SeoMetaTitles } from "@kursk/components/seo/SeoMetaTitles";
import { TicketsBundlesGrid } from "./TicketsBundlesGrid/TicketsBundlesGrid";
import { SubscribeFooterForm } from "@kursk/components/ui/SubscribeFooterForm/SubscribeFooterForm";
import { Filters } from "@kursk/components/ui/Filters/Filters";
import { CatalogueTitle } from "@kursk/components/ui/CatalogueTitle/CatalogueTitle";
import React from "react";

export const TicketsBundles = () => {
  const { total, meta, filters } = useSelectSlice(ticketsBundlesSlice);
  const { listPlaces, listOverviews, listEvents } = useSelectSlice(recommendationSlice);
  const selectedTags = filters.allTags;
  const selectedTag = (meta.tags && selectedTags.length === 1) && meta.tags.find((tag) => tag._id === selectedTags[0]);

  return (
    <Layout showSubscribePopup={false}>
      <SeoMetaTitles
        page="ticketsBundles"
        selectedTag={selectedTag}
        titleOg={getEntitiesListTitle(meta.tags, selectedTags, 'абонементы')}
      />
      <section className={styles.section_content}>
        <div className={styles.header}>
          <CatalogueTitle
            tags={meta.tags}
            selectedTags={selectedTags}
            title={'абонементы'}
            dashTitle={'Найдено абонементов'}
            total={total}
          />
        </div>
        <div className={styles.filters}>
          <Filters
            entityType={'ticketsbundles'}
            filters={filters}
            meta={meta}
            withDates
            withPlaces
            withPrices
            withPricesOptions={{
              withFreeCheckbox: true,
              dropDownTitle: 'Цена (₽)'
            }}/>
        </div>
        <div className={styles.items}>
          <TicketsBundlesGrid/>
        </div>
        <div className={styles.recommendationSection}>
          <RecommendationsBlock
            entityType="places"
            data={listPlaces}
            title={'Рекомендуем побывать'}
            goTo={'/places'}
            goToTitle={'все места'}/>
        </div>
        <div className={styles.recommendationSection}>
          <RecommendationsBlock
            entityType="overviews"
            data={listOverviews}
            title={'Рекомендуем почитать'}
            goTo={'/overviews'}
            goToTitle={'все обзоры'}/>
        </div>
        <div className={styles.recommendationSection}>
          <RecommendationsBlock
            entityType="events"
            data={listEvents}
            title={'Рекомендуем посетить'}
            goTo={'/events'}
            goToTitle={'все события'}/>
        </div>
        <div className={styles.recommendationSection}>
          <SubscribeFooterForm/>
        </div>
        <div className={styles.section}>
          <Socials/>
        </div>
      </section>
    </Layout>
  );
}
